import {Component, Input, OnInit} from '@angular/core';
import {StorageService} from "../../services/storage.service";
import {UserService} from "../../services/user.service";
import {ContentService} from "../../services/content.service";

@Component({
    selector: 'app-lang-switcher',
    templateUrl: './lang-switcher.component.html',
    styleUrls: ['./lang-switcher.component.scss'],
    standalone: false
})
export class LangSwitcherComponent implements OnInit {
    selectedLang: string | null = null;

    // Define all available languages
    languages = [
        {code: 'en', label: 'English'},
        {code: 'cy', label: 'Cymraeg'},
        {code: 'ur', label: 'اردو'},
        {code: 'pl', label: 'Polski'},
        {code: 'ar', label: 'العربية'},
        {code: 'fa', label: 'فارسی'},
        {code: 'syl', label: 'Sylheti'},
        {code: 'bn', label: 'বাংলা'},
        {code: 'es', label: 'Español'},
        {code: 'ro', label: 'Română'},
        {code: 'tr', label: 'Türkçe'},
        {code: 'pt', label: 'Português'},
        {code: 'bg', label: 'Български'},
        {code: 'pa', label: 'ਪੰਜਾਬੀ'},
    ];

    langConfig = {
        header: 'Language',
    };

    @Input() hasBorder: boolean = false;

    constructor(
        public storageService: StorageService,
        public userService: UserService,
        private contentService: ContentService,
    ) {
    }

    async ngOnInit() {
        this.selectedLang = await this.storageService.get('lang') || 'en';
    }

    async setLang(code: string) {
        await this.storageService.set('lang', code);

        if (this.userService.isLoggedIn) {
            try {
                await this.userService.updateLocale();
            } catch (e) {
                console.warn('updateLocale failed', e);
            }
        }

        await this.contentService.clearContentCache();
        window.location.reload();
    }
}
